import type { Wallet } from '../../../../../schema/frameworks/entry.js';
import type { Currency } from '../../../../../schema/lib/entry.js';
import { createBrandedData } from '../../../../../schema/type-utils/entry.js';

/**
 * Returns whether the wallet is a marketplace wallet.
 *
 * @param wallet Wallet to check
 * @returns True if the wallet is a marketplace wallet
 */
// wallet?.type === walletType.WALLET_MARKETPLACE_PLAYER ||
// wallet?.type === walletType.WALLET_MARKETPLACE_RETAILER
export const defaultWallet: Wallet = {
  id: 'WALLET_ID_PLAYER',
  type: 'WALLET_PLAYER',
  label: 'Min spelkassa',
  meta: {
    balance: createBrandedData<Currency>(1337),
  },
} as const;

/**
 * Selects the current active wallet.
 * Can be: player, marketplace player (multiple), retailer or selfservice for example.
 *
 * @returns Current wallet
 */
export function useActiveWallet(): Wallet {
  return defaultWallet; /* state.Wallet.wallets[state.Wallet.activeWallet]; */
}
